/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  NbPasswordAuthStrategy,
  NbAuthModule,
  NbAuthJWTToken,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbOAuth2ResponseType,
} from '@nebular/auth';
import { ApiModule } from './lockvue-ng-sdk/api.module';
import { BASE_PATH } from './lockvue-ng-sdk';

import { LockvueSharedComponentsModule } from './common/lockvue-shared-components.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import {
  NbDatepickerModule,
  NbWindowModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbDialogModule,
  NbAlertModule,
  NbCheckboxModule,
  NbInputModule,
  NbButtonModule,
} from '@nebular/theme';
import { LogoutComponent } from './auth/components/logout/logout.component';
import { AutoLoginComponent } from './auth/components/auto-login/auto-login.component';
import { RegisterSuccessComponent } from './auth/components/register-success/register-success.component';
import { EmailConfirmedComponent } from './auth/components/email-confirmed/email-confirmed.component';
import { ChartModule } from 'angular2-chartjs';
import { ResetPasswordComponent } from './auth/components/reset-password/reset-password.component';
import { FormsModule } from '@angular/forms';
import { RegisterComponent } from './auth/components/register/register.component';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import { RoleProvider } from './auth/lockvue-role.provider';
import { LoginComponent } from './auth/components/login/login.component';
import { AccountResetComponent } from './auth/components/account-reset/account-reset.component';
import { environment } from '../environments/environment';
import { LockvueInterceptor } from './interceptors/lockvue.interceptor';
import { AuthConfigModule } from './auth/auth-config.module';
import { FusionAuthJWTToken, FusionAuthStrategy } from './auth/strategies/fusion-auth.strategy';
import { Oauth2CallbackComponent } from './auth/components/oauth2-callback/oauth2-callback.component';
import { AuthInterceptor } from 'angular-auth-oidc-client';

const API_URL = environment.apiServerUrl; // TODO - set it dynamically at build time!

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    AutoLoginComponent,
    RegisterComponent,
    RegisterSuccessComponent,
    EmailConfirmedComponent,
    ResetPasswordComponent,
    AccountResetComponent,
    Oauth2CallbackComponent,
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDv2VxpaVPJAoq6HcMJtyLUSqkzpTbcXMk',
      libraries: ['places'],
    }),
    AgmJsMarkerClustererModule,

    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    // NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),

    NbDatepickerModule.forRoot(),
    NbWindowModule.forRoot(),

    ApiModule,
    LockvueSharedComponentsModule,

    Ng2SmartTableModule,

    NbAlertModule,
    NbCheckboxModule,
    FormsModule,
    NbInputModule,
    NbButtonModule,

    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDialogModule.forRoot(),

    ChartModule,

    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',

          token: {
            class: NbAuthJWTToken,
            key: 'Token',
          },

          baseEndpoint: environment.authServerUrl,
          login: {
            // ...
            endpoint: '/Account/login?clientId=' + environment.clientId,
            method: 'post',
          },
          register: {
            // ...
            endpoint: '/Account/register?clientId=' + environment.clientId,
            method: 'post',
            redirect: {
              success: 'auth/register-success',
            },
          },
          logout: {
            endpoint: '/Account/logout',
            method: '',
          },
          requestPass: {
            endpoint: '/Account/forgot-password',
            method: 'post',
          },
          resetPass: {
            endpoint: '/Account/reset-password',
            method: 'post',
          },
          refreshToken: {
            endpoint: '/Account/logout',
            method: '',
          },
        }),
        FusionAuthStrategy.setup({
          name: 'fusion-auth',
          clientId: '',
          authorize: {
            responseType: NbOAuth2ResponseType.CODE,
          },
          token: {
            class: FusionAuthJWTToken,
          },
        }),
      ],
      forms: {
        login: {
          rememberMe: false,
        },
        register: {
          terms: false,
        },
        validation: {
          password: {
            required: true,
            minLength: 7,
            maxLength: 50,
          },
          email: {
            required: true,
          },
          fullName: {
            required: false,
            minLength: 1,
            maxLength: 50,
          },
        },
      },
    }),

    NbSecurityModule.forRoot({
      accessControl: {
        AstuteAdmin_View: {
          view: 'admin',
        },
        AstuteAdmin_Admin: {
          parent: 'AstuteAdmin_View',
          modify: 'admin',
          remove: 'admin',
        },
        AstuteWLAdmin_View: {
          view: 'partner_admin',
        },
        AstuteWLAdmin_Admin: {
          parent: 'AstuteWLAdmin_View',
          modify: 'partner_admin',
          remove: 'partner_admin',
        },
      },
    }),
    AuthConfigModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: BASE_PATH, useValue: API_URL },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LockvueInterceptor, multi: true },
    { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: req => !req.url.startsWith(API_URL) },
    { provide: NbRoleProvider, useClass: RoleProvider },
  ],
})
export class AppModule {}
